import { render, staticRenderFns } from "./OrderAwaitingProcess.vue?vue&type=template&id=e05e496a&"
import script from "./OrderAwaitingProcess.vue?vue&type=script&lang=js&"
export * from "./OrderAwaitingProcess.vue?vue&type=script&lang=js&"
import style0 from "./OrderAwaitingProcess.vue?vue&type=style&index=0&id=e05e496a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports